import {
    CalendarDrawerContent,
    CalendarDrawerSettings,
    CalendarState,
} from "burde";
import { D3Selection } from "../draw-calendar";
import { drawBorder } from "../draw-border";
import { Page, PageSelector, CalendarDimensions } from "svg/constants";
import { Moment } from "moment";
import UpdateTemplateLayout from "./update-template-layout";
import {
    SvgCalendarLayout,
    LayoutFont,
    DayModuleElement,
    WeekModuleElement,
} from "ui/constants";

const getClass = (page: Page) =>
    (page === Page.Odd ? PageSelector.Left : PageSelector.Right).replace(
        ".",
        "",
    );

const drawLayout = async (
    svg: D3Selection,
    calendar: CalendarState,
    calendarDrawerSettings: CalendarDrawerSettings,
    page: Page,
    date: Moment,
    Header_WeekNumberPrefix: string,
    layout: SvgCalendarLayout,
    fontData: LayoutFont | null,
    weekModulePlaceholders: boolean,
    dayModuleElements: DayModuleElement[] | null,
    weekModuleElements: WeekModuleElement[] | null,
    calendarDrawerContent: CalendarDrawerContent,
) => {
    const calendarSize =
        calendar.calendarSize != "" ? calendar.calendarSize : "A5";
    const calendarDimensions = CalendarDimensions.find(
        (x) => x.calendarSize === calendarSize,
    );

    if (calendarDimensions == undefined) return;

    var content = svg
        .append("g")
        .classed(`main-content ${getClass(page)}`, true);

    // Prevent end user from seeing the bleeds
    if (calendarDrawerSettings.isConfiguratorView) {
        content.attr("transform", `translate(-30, -30)`);
    }

    if (
        layout.endpoints.leftLayout == undefined ||
        layout.endpoints.rightLayout == undefined
    ) {
        return;
    }

    let layoutTemplate = layout.endpoints.leftLayout;

    if (page == Page.Even) {
        layoutTemplate = layout.endpoints.rightLayout;
    }

    // Add layout to page.
    content.html(layoutTemplate.svgData);

    content
        .select(".outerContent")
        .attr("height", calendarDimensions.contentHeightWithoutBleeds + 60)
        .attr("width", calendarDimensions.contentWidthWithoutBleeds + 60);

    const innerContentHeight = content
        .select(".innerContent")
        .attr("data-height");
    const innerContentWidth = content
        .select(".innerContent")
        .attr("data-width");

    content
        .select(".innerContent")
        .attr("height", innerContentHeight)
        .attr("width", innerContentWidth);

    drawBorder(
        content,
        calendar.borderColor,
        page,
        calendar.calendarSize,
        !calendarDrawerSettings.isConfiguratorView,
        calendarDrawerContent,
    );

    // Update the template with real data.
    await UpdateTemplateLayout(
        content,
        Header_WeekNumberPrefix,
        date,
        layoutTemplate,
        calendar,
        fontData,
        weekModulePlaceholders,
        dayModuleElements,
        weekModuleElements,
        calendarDrawerContent,
    );
};

export default drawLayout;
